import { Component } from '@angular/core';
import { EgRail } from '@expertgroup/shell';
import { environment } from '@/environments/environment';
import { AppMenu } from './app.menu';

/**
 * Sina. Mere, boje i aktivno stanje dolaze iz ljuske; sadrzaj navigacije ostaje
 * Identity-jev (AppMenu).
 *
 * Ime, logotip, znak i alt dolaze iz maske (shell 0.16, `provideIdentityBrand`): maska HOSTA sa Identity-ja, a bez nje
 * Identity-jeva generička — ime „Identity", bez logotipa i znaka. Sina zato ne nosi nijedan od njih: zakucan EG logotip bi
 * stajao i na domenu tenanta, ispod njegove maske.
 *
 * Nestalo je: hover-expand sa 300ms timeout-om, IntersectionObserver,
 * matchMedia('(min-width: 992px)') listener, outside-click vezivanje i pisanje
 * `--menu-scroll-x/y` custom propertija. Sve je postojalo da bi sina mogla da
 * bude sedam razlicitih stvari. Sada je jedna.
 *
 * The rail footer carries the environment name (`environment.name`: lokalno / staging). Production
 * has an empty name and the shell draws no badge for an empty `env`, so production shows none.
 */
@Component({
    selector: '[app-sidebar]',
    standalone: true,
    imports: [EgRail, AppMenu],
    template: `<eg-rail [env]="env">
        <div app-menu></div>
    </eg-rail>`
})
export class AppSidebar {
    /** Environment badge text; '' (production) renders none. */
    protected readonly env = environment.name;
}
